import { useQuery } from "@tanstack/react-query";
import { api } from "./api";
import { clerkClient } from "@/App";
import { DateRange } from "react-day-picker";

export type HeatmapAnalyticsResponse = {
  type: "FeatureCollection";
  features: {
    type: "Feature";
    geometry: { type: "Point"; coordinates: [number, number] };
    properties: {
      count: number;
      weight: number;
      h3_index: string;
    };
  }[];
};

export const fetchAnalyticsHeatmap = async (
  precision: number,
  dateRange?: DateRange
): Promise<HeatmapAnalyticsResponse> => {
  const authToken = await clerkClient.session?.getToken();

  const params: Record<string, any> = { precision };
  
  if (dateRange?.from) {
    params.start_time = dateRange.from.toISOString();
  }
  if (dateRange?.to) {
    params.end_time = dateRange.to.toISOString();
  }

  const response = await api.get("/v0/analytics/heatmap", {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    params,
  });
  return response.data;
};

export const useAnalyticsHeatmap = (precision: number, dateRange?: DateRange) => {
  return useQuery({
    queryKey: ["analytics-heatmap", precision, dateRange?.from?.toISOString(), dateRange?.to?.toISOString()],
    queryFn: () => fetchAnalyticsHeatmap(precision, dateRange),
    refetchOnWindowFocus: false,
  });
};
